<template>
  <div class="content faq">
    <div v-for="item in blocks">
      <h2 @click="toogleActive(item)">
        <span>{{ $t(item.title)}}</span>
        <i class="material-icons arrow-i" :class="{'active': item.active}">keyboard_arrow_right</i>
      </h2>
      <div class="collapse-div" v-show="item.active" >
        <span v-html="$t(item.content)" style="display: inline-block; font-size: 16px"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      blocks: [
        { title: 'How to place an order on the website?',
          content: 'Placing an order is extremely simple. Here`s what you need to do: 1. Choose a category and the desired establishment/shop/service. Fill your basket. 2. Go to the order. Fill in your personal data, specify the method and address of delivery, the desired time of receipt and the method of payment. 3. You will receive an SMS confirmation with the order number. Wait for your order at the chosen time.',
          active: true
        },
        { title: 'Is it possible to order delivery from an institution that is not a partner or delivery from any point of sale?',
          content: 'Our service is a universal courier service. In the “Anything“ section, you can describe what exactly you want to receive or deliver, and the couriers of our service will do their best to fulfill this order.',
          active: false
        },
        { title: 'Is it possible to make a scheduled order for the specified hour?',
          content: 'In addition to “As soon as possible“ delivery, our website also has the option of arranging scheduled delivery for a specific day or hour.',
          active: false
        },
        { title: 'Is it possible to place an order from several spots with simultaneous delivery?',
          content: 'Only with us you can place an order from several spots and receive them at the same time.',
          active: false
        },
        { title: 'What is the shipping cost?',
          content: 'The cost of delivery within the city and suburban area of Ternopil ranges from 0 to 200 UAH and depends on the institution, service and order amount you have chosen. More details with the cost of delivery from any institution, store or service “Anything!“ you can find out in the “Delivery cost“ section.',
          active: false
        },
        { title: 'Do the couriers deliver to the apartment or only to the entrance?',
          content: 'According to the service rules, we deliver to the door. However, if you want delivery to the entrance or for the courier to leave the order at the door of the apartment - indicate this in the comments to the order and we will take your wishes into account.',
          active: false
        },
        { title: 'What are the payment methods for the order?',
          content: 'We can pay for your order in cash or online payment.',
          active: false
        },
        { title: 'Can the courier make an additional purchase in addition to the main order?',
          content: 'The courier can make an additional purchase. To do this, you need to apply through the website in the “Anything“ section for an additional fee.',
          active: false
        },
        { title: 'Do you deliver to parks and recreation areas?',
          content: 'Yes, we can deliver using geolocation data.',
          active: false
        },
        { title: 'What is the delivery schedule?',
          content: 'You can place an order on the website 24 hours a day, but orders are processed and delivered daily from 10:00 a.m. to 9:45 a.m.',
          active: false
        },
        { title: 'How do I make changes to or cancel a scheduled order?',
          content: 'If you want to make changes to the planned order or cancel it, call or write to us via Viber or Telegram at the current number indicated in the ”Contacts” section. Our operators will make adjustments or cancel your order, if possible.',
          active: false
        },
        { title: 'How to change phone number?',
          content: 'You can change the contact number in your profile information. After making changes, you will receive a verification code. Your number will be changed immediately after confirming this code. If you have not received the verification code, please contact us at the current number indicated in the “Contacts“ section.',
          active: false
        },
        { title: 'How to change the password?',
          content: 'You can change the password associated with your account in your profile information. Enter the current password, a new one and additionally confirm the new password. After confirming the changes, the password will be updated.',
          active: false
        }
      ]
    }
  },
  computed: {
    faqPageSchema () {
      return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: this.blocks.map(item => ({
          '@type': 'Question',
          name: this.$t(item.title),
          acceptedAnswer: { '@type': 'Answer', text: this.$t(item.content) }
        }))
      }
    }
  },
  methods: {
    toogleActive (item) {
      item.active = !item.active
    },
    // '<' escaped so translated Q&A text can never break out of the inline
    // JSON-LD script block, matching CategorySeoContent.vue's toJsonLd().
    toJsonLd (value) {
      return JSON.stringify(value).replace(/</g, '\\u003c')
    }
  },
  metaInfo () {
    return {
      script: [
        { type: 'application/ld+json', innerHTML: this.toJsonLd(this.faqPageSchema), vmid: 'ld-faq' }
      ],
      // Without this, vue-meta HTML-entity-escapes innerHTML by default -
      // see CategorySeoContent.vue's identical comment for the full reason.
      __dangerouslyDisableSanitizers: ['script']
    }
  }
}
</script>


<style lang="scss" scoped>
  .content {
    margin-top: 40px;
    padding: 0 20px;
    -webkit-text-size-adjust: 100%;

    h2 {
      cursor: pointer;
      font-size: 24px;
      color: #111;
      margin: 0;
      font-weight: normal;
      border-top: 1px solid #ebebeb;
      margin-top: 15px;
      padding-top: 15px;
      position: relative;

      span {
        max-width: calc(100% - 40px);
        display: inline-block;
      }
    }
    .collapse-div {
      margin-top: 15px;
      font-size: 16px;
      line-height: 26px;

    }
    i.arrow-i.active {
      -webkit-transform: rotate(-90deg);
      -ms-transform: rotate(-90deg);
      transform: rotate(-90deg);
      color: #11bb2e;
    }
    i.arrow-i {
      background-color: #f5f5f5;
      padding: 5px;
      border-radius: 50%;
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 14px;
      -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: rotate(90deg);
      color: #11bb2e;
    }
  }

</style>
